/* eslint-disable camelcase */
import { utilService } from '@services';
import { getTimeElapsedToDate } from '@helpers/sendEmail';
import * as commonTypes from './actionTypes';
import * as loggedActions from '../logged/actions';

export const showError = (codeError) => ({
  type: commonTypes.SHOW_ERR_MSG,
  payload: codeError,
});

export const setRouter = ({ isAllowed, redirectTo }) => ({
  type: commonTypes.SET_ROUTER,
  payload: { isAllowed, redirectTo },
});

export const showLoading = () => ({
  type: commonTypes.SHOW_ON_LOADING,
});

export const hideLoading = () => ({
  type: commonTypes.HIDE_ON_LOADING,
});

export const showSkeleton = () => ({
  type: commonTypes.SHOW_ON_SKELETON,
});

export const hideSkeleton = () => ({
  type: commonTypes.HIDE_ON_SKELETON,
});

export const hideModal = () => ({
  type: commonTypes.HIDE_MODAL,
});

export const setModalResult = (result) => ({
  type: commonTypes.SET_MODAL_RESULT,
  payload: result,
});

export const setModalDataAndShow = ({
  title,
  paragraph,
  subtitle,
  imgSrc,
  firstButtonClass,
  firstButtonText,
  respOnClickFirst,
  showSecondButton,
  secondButtonClass,
  secondButtonText,
  respOnClickSecond,
}) => ({
  type: commonTypes.SET_MODAL_DATA_AND_SHOW,
  payload: {
    title,
    paragraph,
    subtitle,
    imgSrc,
    firstButtonClass,
    firstButtonText,
    respOnClickFirst,
    showSecondButton,
    secondButtonClass,
    secondButtonText,
    respOnClickSecond,
  },
});

export const hideSnackBar = () => ({
  type: commonTypes.HIDE_SNACKBAR,
});

export const setSnackBarResult = (result) => ({
  type: commonTypes.SET_SNACKBAR_RESULT,
  payload: result,
});

export const setSnackBarDataAndShow = ({
  // type,
  // imgSrc,
  title,
}) => ({
  type: commonTypes.SET_SNACKBAR_DATA_AND_SHOW,
  payload: {
    title,
    // imgSrc,
    // type,
  },
});

export const setLegalText = (text) => ({
  type: commonTypes.SET_LEGAL_TEXT,
  payload: text,
});

export const setDocumentsTypes = (...data) => ({
  type: commonTypes.SET_DOCUMENTS_TYPES,
  payload: { ...data },
});

export const getDocumentsTypes = () => (dispatch) =>
  utilService
    .getDocuments()
    .then(({ doc_types }) => dispatch(setDocumentsTypes(...doc_types)))
    .catch((error) => dispatch(loggedActions.showError(error)));

export const setBankCodes = (...data) => ({
  type: commonTypes.SET_BANK_CODES,
  payload: { ...data },
});

export const getBankCodes = () => (dispatch) =>
  utilService
    .getBanks()
    .then(({ bankCodes }) => dispatch(setBankCodes(...bankCodes)))
    .catch((error) => dispatch(loggedActions.showError(error)));

export const setNpsWidget = (data) => ({
  type: commonTypes.SET_NPS_WIDGET,
  payload: data,
});

export const getNpsWidget = () => (dispatch) =>
  utilService
    .getNpsWidget()
    .then(({ npsWidget }) => dispatch(setNpsWidget(npsWidget)))
    .catch((error) => dispatch(loggedActions.showError(error)));

export const setModal = (value) => ({
  type: commonTypes.SET_MODAL,
  payload: value,
});

export const setContactEmail = (text) => ({
  type: commonTypes.SET_CONTACT_EMAIL,
  payload: text,
});

export const getContactEmail = () => (dispatch) =>
  utilService
    .getContactEmail()
    .then(({ email }) => dispatch(setContactEmail(email)))
    .catch((error) => dispatch(loggedActions.showError(error)));

export const setFormValidationErrors = ({ hasError, fields }) => ({
  type: commonTypes.SET_FORM_VALIDATION_ERRORS,
  payload: { hasError, fields },
});

export const clearFormValidationErrors = () => (dispatch) => {
  dispatch(setFormValidationErrors({ hasError: false, fields: [] }));
};

export const setTimersSentEmail = (timersSentEmail) => ({
  type: commonTypes.SET_TIMER_SENT_EMAIL,
  payload: timersSentEmail,
});

export const setNewTimersSentEmailByEmail =
  ({ email, token }) =>
  (dispatch, getState) => {
    const {
      common: { timersSentEmail = [] },
      config: {
        send_email: {
          time_limit: timeLimit = 120,
          type_of_time_limit: typeOfTimeLimit = 'seconds',
        },
      },
    } = getState();
    const restTimerEmail = timersSentEmail
      .filter((timerEmail) => getTimeElapsedToDate(timerEmail, { timeLimit, typeOfTimeLimit }) > 0)
      .filter((timerEmail) => timerEmail.email !== email);
    const newTimersSentEmail = { timeSent: new Date(), email, token };

    dispatch(setTimersSentEmail([...restTimerEmail, newTimersSentEmail]));
  };

export const deleteTimerSentByEmail = (email) => (dispatch, getState) => {
  const {
    common: { timersSentEmail = [] },
  } = getState();
  const restTimerEmail = timersSentEmail.filter((timerEmail) => timerEmail.email !== email);

  dispatch(setTimersSentEmail(restTimerEmail));
};

export const showBanners = () => ({
  type: commonTypes.SHOW_BANNERS,
});

export const hideBanners = () => ({
  type: commonTypes.HIDE_BANNERS,
});
